import request from "@/utils/request";

// 列表(主数据列表)
export function loadTobaccoVisitListListDataApi(data) {
  return request({
    url: "web/tobaccoVisitList/listData",
    method: "post",
    data
  });
}
// 导出
export function loadTobaccoVisitListExportDataApi(data) {
  return request({
    url: "web/tobaccoVisitList/exportData",
    method: "post",
    data
  });
}
// 初始化
export function initTobaccoVisitListApi(data) {
  return request({
    url: "web/tobaccoVisitList/init",
    method: "post",
    data
  });
}
// 操作
export function saveOrUpdateTobaccoVisitListApi(data) {
  return request({
    url: "web/tobaccoVisitList/saveOrUpdate",
    method: "post",
    data
  });
}
// 根据条件查询数量
export function findCountByConditionApi(data) {
  return request({
    url: "web/tobaccoVisitList/findCountByCondition",
    method: "post",
    data
  });
}
